module.exports = __webpack_public_path__ + "static/life-feynman-diagram-0f4bf5bf37a7d29a4abf5006e3a44c52.png";